/* eslint-disable camelcase */
import React from 'react'
import Money from './Money'
import ReactHtmlParser from 'react-html-parser'; 
interface PriceProps {
  originalPrice: number,
  finalPrice: number,
  priceVaries: boolean,
  priceMin?: number,
  priceMax?: number,
  withCurrency?: boolean //optionally use the shopify "with currency" format, eg. currency code after price
}

interface PriceVariationProps {
  priceMin: number,
  priceMax?: number
}

const PriceVariation : React.FunctionComponent<PriceVariationProps> = ({ priceMin, priceMax })  => {
  const { fromTextHtml } = window['theme'].strings
  const { fromToTextHtml } = window['theme'].strings
  const transform = (node: Record<string, any>, i: number): JSX.Element | void => {
    if (node.data === '[[price]]' || node.data === '[[price_min]]') {
      return <Money key={i} amount={priceMin} ></Money>
    }
    if (node.data === '[[price_max]]') {
      return <Money key={i} amount={priceMax} ></Money>
    }
  }
  return <>{ReactHtmlParser((priceMax ? fromToTextHtml : fromTextHtml), { transform })}</>;
}  


const Price = ({priceVaries, originalPrice, finalPrice, priceMin, priceMax, withCurrency} : PriceProps): JSX.Element => {
  return (
    <p className="product-price">
      { priceVaries && <PriceVariation priceMin={priceMin} priceMax={priceMax} ></PriceVariation>}
      { !priceVaries && <>
        { finalPrice !== originalPrice ? <s><Money amount={originalPrice} /></s> : null}
        <span>
          <Money withCurrency={withCurrency} amount={finalPrice} />
        </span>
      </>}
    </p>
  )
}


export default Price